<article class="text-center">
  <h2 class="text-info"><b>400</b> Thats an error!</h2>
  <p>Your client has issued a malformed or illegal request. </p>
  <small>Thats all we know.</small>
</article>